import React, { Fragment, FunctionComponent, PropsWithChildren } from "react";

import { VerticalDivider } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { DividerPosition } from "./enums";

export type ToolbarSectionProps = PropsWithChildren<{
    dividerPosition?: DividerPosition;
}>;

const classNames = bemClassNames("toolbar-section");
const wfToolbarSection = classNames();

export const ToolbarSection: FunctionComponent<ToolbarSectionProps> = ({ children, dividerPosition = DividerPosition.right }) => (
    <Fragment>
        {dividerPosition === DividerPosition.left && <VerticalDivider />}
        <div className={wfToolbarSection} >
            {children}
        </div>
        {dividerPosition === DividerPosition.right && <VerticalDivider />}
    </Fragment>
);
